"use client";

import { useEffect, useState } from "react";
import { buildBackToOrderHref } from "@/app/artifacts/table/parseTableUrl";
import { readLastWorkspace } from "@/lib/lastWorkspaceStorage";

/** Client href for “กลับหน้าหลัก” — `/?workspaceId=…&source=order` from `aera_last_workspace`, else `/`. */
export function useBackToHomeHref(): string {
  const [href, setHref] = useState("/");

  useEffect(() => {
    setHref(buildBackToOrderHref(readLastWorkspace(), null));
  }, []);

  return href;
}
